import React, { useState } from 'react';
import './ZilchTooltip.css';
import { AiFillQuestionCircle } from "react-icons/ai";


/**
 * ZilchTooltip - A reusable inline tooltip component with Zilch logo
 * 
 * Features:
 * - Inline tooltip that appears next to inputs or any element
 * - Only displays when copy prop is provided
 * - Shows tooltip on hover
 * - Responsive design
 * 
 * Usage:
 * // Standalone icon with tooltip
 * <ZilchTooltip copy="Your helpful tooltip text here" />
 * 
 * // Next to an input (inline)
 * <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
 *   <input type="text" />
 *   <ZilchTooltip copy="Help text for this input" />
 * </div>
 * 
 * // Next to a label
 * <label>
 *   Product Name
 *   <ZilchTooltip copy="Enter the name of your product" />
 * </label>
 * 
 * @param {string} copy - The text content to display in the tooltip. Tooltip only renders if copy is provided.
 * @param {string} position - Tooltip position relative to icon ('right' | 'left' | 'top' | 'bottom')
 * @param {number} logoSize - Optional logo size in pixels (default: 16)
 * @param {string} className - Optional additional CSS class
 */
function ZilchTooltip({ copy, position = 'right', logoSize = 16, className = '' }) {
  const [isVisible, setIsVisible] = useState(false);

  // Don't render if no copy is provided
  if (!copy || copy.trim() === '') {
    return null;
  }

  return (
    <span 
      className={`zilch-tooltip-wrapper ${className}`}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <span className="zilch-tooltip-icon">
        <AiFillQuestionCircle size={logoSize} color="#6b7280" />
      </span>
      {isVisible && (
        <span className={`zilch-tooltip-content zilch-tooltip-${position}`}>
          <span className="zilch-tooltip-arrow"></span>
          <span className="zilch-tooltip-text">
            {copy}
          </span>
        </span>
      )}
    </span>
  );
}

export default ZilchTooltip;

